import {
  ICustomProperties,
  SeverityLevel,
} from '@microsoft/applicationinsights-web';

import { reactPlugin } from './reactPlugin';

interface Properties extends ICustomProperties {
  customErrorType?: string;
}

export const logError = (error: unknown, customProperties?: Properties) => {
  return reactPlugin.trackException({
    exception: error as Error,
    properties: {
      currentPage: window.location.href,
      ...customProperties,
    },
    severityLevel: SeverityLevel.Error,
  });
};
